import React, { useEffect } from "react";
import { shallow } from "zustand/shallow";
import useGameStore from "store/gameStore";
import Loader from "components/Loader";
import classNames from "classnames";
import { CanvasView } from "core/enums";
import styles from "styles/components/pixiContainer.module.css";
import sessionHelper from "service/sessionHelper";

interface CanvasProps {
  view?: CanvasView | null;
  iframe?: any;
}

const PixiContainer: React.FC<CanvasProps> = ({ iframe }) => {
  const { canvasReady } = useGameStore(
    (state) => ({
      canvasReady: state.canvasReady,
    }),
    shallow,
  );

  // useEffect(() => {
  //   //@ts-ignore
  //   if (window?.initPixi && canvasReady && view) {
  //     //Delaying the init call beacuase dimension fetching was incorrect
  //     setTimeout(() => {
  //       const _getParentDimensions = () => {
  //         let canvasStage = document.getElementById("gameStage");

  //         return { height: canvasStage?.offsetHeight, width: canvasStage?.offsetWidth };
  //       };

  //       //@ts-ignore
  //       window?.initPixi({
  //         view,
  //         canvasDimension: _getParentDimensions(),
  //         initData: sessionHelper.initData,
  //         urls: {
  //           apiUrl: process.env.REACT_APP_API_URL,
  //           socket: process.env.REACT_APP_SOCKET_URL,
  //           external: process.env.REACT_APP_EXTERNAL_URL,
  //         },
  //       });
  //     }, 100);
  //   }

  //   return () => {
  //     //@ts-ignore
  //     if (window?.unmountScreen) {
  //       //@ts-ignore
  //       // window?.unmountScreen({ event: "UNMOUNT", view });// temporary coment for dev purpose
  //     }
  //   };
  // }, [canvasReady, view]);

  useEffect(() => {
    //@ts-ignore
    if (window?.initPixi && canvasReady) {
      // Delaying the init call because dimension fetching was incorrect
      // setTimeout(() => {
      try {
        const _getParentDimensions = () => {
          const canvasStage = document.getElementById("gameStage");
          return {
            height: canvasStage?.offsetHeight || 0,
            width: canvasStage?.offsetWidth || 0,
          };
        };

        //@ts-ignore
        window.initPixi({
          // view,
          canvasDimension: _getParentDimensions(),
          initData: sessionHelper.initData,
          urls: {
            apiUrl: process.env.REACT_APP_API_URL,
            socket: process.env.REACT_APP_SOCKET_URL,
            external: process.env.REACT_APP_EXTERNAL_URL,
          },
        });
      } catch (err) {
        console.error("🔥 Error during initPixi:", err);
      }
      // }, 100);
    }

    return () => {
      //@ts-ignore
      if (window?.unmountScreen) {
        try {
          //@ts-ignore
          window.unmountScreen({ event: "UNMOUNT", view }); // temporary comment for dev purpose
        } catch (err) {
          console.error("⚠️ Error during unmountScreen:", err);
        }
      }
    };
  }, [canvasReady]);

  return (
    <div className={classNames(styles.iframeContainer, {})}>
      <iframe
        id="canvas"
        src="canvas/index.html"
        className="h-full w-full"
        sandbox="allow-scripts allow-same-origin" 
        loading="eager"
        allow="fullscreen"
        ref={iframe}
      />
    </div>
  );
};

export default React.memo(PixiContainer);
